module.exports = __webpack_public_path__ + "img/estoque.64f85c06.jpg";